module.exports = __webpack_public_path__ + "img/carts.67789caa.png";